import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner, TableRow } from '@/core/ui';
import { memo } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { TableCellStyled } from './InfiniteScrollSpinner.styled';
/**
 *  Should be used in {@link Table} components inside {@link TableFooter}.
 */
const InfiniteScrollSpinner = memo(({ columnCount, itemCount, isLoading, isFetching, isError, isLast, onShown }) => {
    const { ref } = useIntersectionObserver({
        threshold: 0.5,
        onChange: (isIntersecting) => {
            // Without this checks multiple api fetches is executed on page mount.
            if (isIntersecting && !isLoading && !isFetching && !isError && isLast === false) {
                onShown();
            }
        },
    });
    // This check must not be placed here. `onChange` will fire multiple times on every rerender.
    // if (isLoading || isFetching || isError || !itemCount || isLast || isLast === undefined) return null;
    return (_jsx(TableRow, { ref: ref, children: _jsx(TableCellStyled, { colSpan: columnCount, children: !isLoading && !isError && Boolean(itemCount) && isLast === false && _jsx(Spinner, {}) }) }));
});
export { InfiniteScrollSpinner };
